export default __webpack_public_path__ + "static/media/35_3_0.efe4d087.png";